const component = require('../component/component');

const label = Object.assign({}, component, {
    formPostData: function (formPostData) {
        return formPostData;
    },

    setElementValue: function (value) {
        this.element.innerHTML = value;
        this.dispatchChangeEvents();
    },

    getValue: function () {
        return this.rawValue;
    }
});

module.exports = label;